export enum DiscountType {
  Percentage = "Percentage",
  Amount = "Amount",
}
